const menu = {
  state: {
    //面包屑导航栏中的地图部分
    mapDisplay: true,
    //左侧导航栏的显隐性
    sideBar: "none",
    //权限列表
    permList: "",
    //处理过后的权限列表
    ProcessingPermList: "",
    //主题颜色
    color: "",
    //当前激活的组件
    currentActiveComponent: null,
    csystem: "",
    //缩放的比例
    scale: 1,
    //侧边栏的激活索引
    sideBarIndex: 0,
    _axiosPromiseCancel: [] //AXIOS发送的请求
  },
  mutations: {
    //面包屑导航栏中的地图部分的修改
    changeMapDisplay(state, mapDisplay) {
      state.mapDisplay = mapDisplay;
    },
    //左侧导航栏的显隐性状态的修改
    changeSideBar(state, sideBar) {
      state.sideBar = sideBar;
    },
    //提交权限列表
    commitPermList(state, permList) {
      state.permList = permList;
    },
    //提交处理过后的权限列表
    commitProcessingPermList(state, permList) {
      state.ProcessingPermList = permList;
    },
    //主题颜色的修改
    SET_Theme(state, color) {
      state.color = color;
    },
    //当前处于激活状态下的组件
    SET_CurrentActiveComponent(state, currentActiveComponent) {
      state.currentActiveComponent = currentActiveComponent;
    },
    //当前激活的系统
    SET_Csystem(state, csystem) {
      state.csystem = csystem;
    },
    SET_SCALE(state, scale) {
      state.scale = scale;
    },
    SET_SideBarIndex(state, sideBarIndex) {
      state.sideBarIndex = sideBarIndex;
    },
    Push_axiosPromiseCancel(state, _axiosPromiseCancel) {
      state._axiosPromiseCancel.push(..._axiosPromiseCancel);
    },
    Remove_axiosPromiseCancel(state, list_key) {
      state._axiosPromiseCancel = state._axiosPromiseCancel.filter(item => {
        return !list_key.map(key => key.key).includes(item.key);
      });
    },
    Clear_axiosPromiseCancel(state) {
      state._axiosPromiseCancel = [];
    }
  },

  actions: {
    /**
     * 修改面包屑导航中的地图部分的显隐性
     */
    changeMapDisplay: ({ commit }, mapDisplay) => commit("changeMapDisplay", mapDisplay), // 提交到mutations中处理
    //是否显示左侧的侧边栏
    changeSideBar: ({ commit }, sideBar) => commit("changeSideBar", sideBar),
    //初始化时将权限数据存入state中，防止以后调用
    commitPermList: ({ commit }, permList) => commit("commitPermList", permList),
    //初始化时将处理过后的权限数据存入state中，防止以后调用
    commitProcessingPermList: ({ commit }, permList) => commit("commitProcessingPermList", permList),
    //主题颜色的修改
    SET_Theme: ({ commit }, color) => commit("SET_Theme", color), // 提交到mutations中处理
    //当前激活状态下的组件
    SET_CurrentActiveComponent: ({ commit }, CurrentActiveComponent) => commit("SET_CurrentActiveComponent", CurrentActiveComponent),
    //设置当前所属系统
    SET_Csystem: ({ commit }, csystem) => commit("SET_Csystem", csystem)
  }
};

export default menu;
